// import React from 'react';
// import { usePermissions } from './usePermissions2';

// type Props = {
//   permission: string | string[];
//   mode?: 'any' | 'all'; // إذا permission مصفوفة
//   fallback?: React.ReactNode; // اختياري
//   children: React.ReactNode;
// };

// export const Can: React.FC<Props> = ({ permission, mode = 'all', fallback = null, children }) => {
//   const { can, canAny, canAll } = usePermissions();

//   const allowed =
//     typeof permission === 'string' ? can(permission) : mode === 'any' ? canAny(permission) : canAll(permission);

//   return <>{allowed ? children : fallback}</>;
// };


import React from 'react';
import { usePermissions } from './usePermissions';

/**
 * Props الخاصة بمكوّن Can
 */
type Props = {
  /**
   * الصلاحية المطلوبة:
   * - إما String واحدة مثل: "ViewlistHrPerJob"
   * - أو مصفوفة صلاحيات مثل: ["PermA", "PermB"]
   */
  permission: string | string[];

  /**
   * وضع التحقق عند تمرير مصفوفة permissions:
   * - "all" (الافتراضي): لازم يملك كل الصلاحيات الموجودة بالمصفوفة
   * - "any": يكفي يملك أي صلاحية واحدة من المصفوفة
   */
  mode?: 'any' | 'all';

  /**
   * ماذا نعرض إذا المستخدم لا يملك الصلاحية؟
   * - null (الافتراضي): لا تعرض شيء (إخفاء كامل)
   * - أو يمكن تمرير عنصر بديل مثل زر disabled أو رسالة "لا تملك صلاحية"
   */
  fallback?: React.ReactNode;

  /**
   * المحتوى الذي تريد عرضه إذا المستخدم لديه الصلاحية
   */
  children: React.ReactNode;
};

/**
 * مكوّن Can:
 * - يتحقق من الصلاحيات
 * - إذا مسموح: يعرض children
 * - إذا غير مسموح: يعرض fallback
 */
export const Can: React.FC<Props> = ({
  permission,
  mode = 'all',       // الافتراضي: all (إذا كانت permission مصفوفة)
  fallback = null,    // الافتراضي: لا تعرض شيء عند عدم وجود صلاحية
  children
}) => {
  // دوال التحقق من الصلاحيات قادمة من hook مركزي
  // can      : يتحقق من صلاحية واحدة
  // canAny   : يتحقق هل لديه أي صلاحية من مصفوفة
  // canAll   : يتحقق هل لديه كل الصلاحيات في مصفوفة
  const { can, canAny, canAll } = usePermissions();

  /**
   * allowed = هل مسموح للمستخدم رؤية المحتوى؟
   *
   * الحالة 1: permission عبارة عن String
   *    => نستخدم can(permission)
   *
   * الحالة 2: permission عبارة عن مصفوفة
   *    - إذا mode === "any" => نستخدم canAny(permission)
   *    - غير ذلك (all)      => نستخدم canAll(permission)
   */
  const allowed =
    typeof permission === 'string'
      ? can(permission)
      : mode === 'any'
        ? canAny(permission)
        : canAll(permission);

  /**
   * إذا allowed = true => اعرض children
   * إذا allowed = false => اعرض fallback (أو لا شيء لو fallback = null)
   */
  return <>{allowed ? children : fallback}</>;
};
